<template>
  <div>
    <div class="flex items-center p-2">
      <a class="inline-block p-1 outline-none border-2 border-transparent rounded focus:border-red-500" href="#" ref="yes"
        @keydown.down="onDown" @keydown.space="onYes" @click.prevent="onYes">
        <font-awesome-icon :icon="['far', value ? 'check-circle' : 'circle']" size="lg" />
      </a>
      <div class="ml-2 font-bold">Ja</div>
    </div>
    <div class="flex items-center">
      <a class="inline-block p-1 outline-none border-2 border-transparent rounded focus:border-red-500" href="#" ref="no"
        @keydown.up="onUp" @keydown.space="onNo" @click.prevent="onNo">
        <font-awesome-icon :icon="['far', value ? 'circle' : 'check-circle',]" size="lg" />
      </a>
      <div class="ml-2 font-bold">Nei</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'yes-no',
  props: ['value'],
  methods: {
    onYes () {
      this.$emit('input', true)
    },
    onNo () {
      this.$emit('input', false)
    },
    onDown () {
      this.$refs.no.focus()
    },
    onUp () {
      this.$refs.yes.focus()
    }
  }
}
</script>